<template>
  <FormGroup :label="label" :inputId="idCalc" :errors="errorsCalc" :successes="successes">
    <multiselect
      class="form-control"
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :id="idCalc"
      :name="name"
      v-model="state.selectedItems"
      :multiple="multiple"
      :options="options"
      :disabled="disabled"
      :label="optionLabel"
      :track-by="optionTrackBy"
      :searchable="false"
      @input="emitInput"
    />
  </FormGroup>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";
import Multiselect from "vue-multiselect";
import { reactive } from "@vue/composition-api";

export default {
  name: "FormMultiSelect",
  mixins: [FormMixin],
  props: {
    options: {
      type: Array,
      validator: (values) => {
        if (!Array.isArray(values)) {
          return false;
        }

        return values;
      },
    },
    optionLabel: String,
    optionTrackBy: String,
    multiple: Boolean,
    value: [Array, String],
    disabled: Boolean,
  },
  components: {
    FormGroup,
    Multiselect,
  },
  setup(props, { emit }) {
    const state = reactive({ selectedItems: [] });
    const emitInput = () => {
      emit(
        "input",
        props.multiple
          ? state.selectedItems.map((item) => item[props.optionTrackBy].toString())
          : state.selectedItems[props.optionTrackBy].toString()
      );
    };

    return {
      state,
      emitInput,
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  box-sizing: border-box;
  min-height: 30px;
  &.form-control {
    padding: 0;
  }
}
.multiselect__tags {
  background: none;
  border: none;
  font-size: 0.75rem;
  padding: 6px 40px 0 12px;
  min-height: 30px;
}
.multiselect__single {
  font-size: 0.75rem;
  padding-left: 0;
}
.multiselect__select {
  height: 30px;
}
.multiselect__placeholder {
  padding-top: 0;
}
.multiselect__tag-icon {
  line-height: 18px;
}
.multiselect__option {
  padding: 8px 12px;
  min-height: 30px;
  line-height: 16px;
  &:after {
    line-height: 30px;
  }
}
</style>
